import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../state/reducers/authReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});
